import type { HTMLMotionProps } from "motion/react"
import type { ReactNode } from "react"
import { forwardRef } from "react"
import { motion } from "motion/react"

export interface SlideBaseProps {
	nextSlide: () => void
}

interface SlideWrapperProps extends HTMLMotionProps<"div"> {
	children: ReactNode
}

export const SlideWrapper = forwardRef<HTMLDivElement, SlideWrapperProps>(
	({ children, ...props }, ref) => {
		return (
			<motion.div
				ref={ref}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				{...props}
			>
				{children}
			</motion.div>
		)
	},
)
